import Cancel from "../../assets/images/cancel.svg";
import SearchableDD from "../searchableDropdown/SearchableDD";

const AdvancedFilters = function ({
  closeAdvanced,
  clearFilters,
  contrastColorsMenu,
  colorsMenu,
  compMenu,
  weaveMenu,
  collarMenu,
  cuffMenu,
  fabricMenu,
  updateFilterValue,
  fabric,
  contrastColorsSelection,
  colorsSelection,
  compSelection,
  weaveSelection,
  collarSelection,
  cuffSelection }) {
  return (
    <div className="adv-filters">
      <div className="overlay"></div>
      <div className="content">
        <div className="head">
          <p className="title">Erweiterter Filter</p>
          <img className="close-modal filters-sheet-close" src={Cancel} alt="" onClick={() => {
            closeAdvanced();
            clearFilters();
          }} />
        </div>
        <div className="filters-entries">

          <div className="filter-entry">
            <p className="label">Stoffname</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={fabricMenu}
                selectedInps={fabric}
                updateFilterValue={updateFilterValue}
                filterName="fabric" diffInp="fabricsNamesInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Kontraststoff</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={contrastColorsMenu}
                selectedInps={contrastColorsSelection}
                updateFilterValue={updateFilterValue}
                filterName="contrast-color" diffInp="contrastInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Farbe des Hauptstoffes</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={colorsMenu}
                selectedInps={colorsSelection}
                updateFilterValue={updateFilterValue}
                filterName="colors" diffInp="colorsInp" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Zusammensetzung des Hauptstoffes</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={compMenu}
                selectedInps={compSelection}
                updateFilterValue={updateFilterValue}
                filterName="composition" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Webart des Hauptstoffes</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={weaveMenu}
                selectedInps={weaveSelection}
                updateFilterValue={updateFilterValue}
                filterName="weave" />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Kragen-Nummer</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={collarMenu}
                selectedInps={collarSelection}
                updateFilterValue={updateFilterValue}
                filterName="collar" showID={true}
              />
            </div>
          </div>
          <div className="filter-entry">
            <p className="label">Manschetten-Nummer</p>
            <div className="select-menu-inps">
              <SearchableDD active={true}
                placeholder={"Suche..."}
                entries={cuffMenu}
                selectedInps={cuffSelection}
                updateFilterValue={updateFilterValue}
                filterName="cuff" showID={true}
              />
            </div>
          </div>
        </div>
        <div className="apply-filters-btn" onClick={() => closeAdvanced()}>
          Filter übernehmen
        </div>
      </div>
    </div>
  )
}

export default AdvancedFilters;